import {
  Fuel,
  Car,
  Home,
  Zap,
  ShoppingCart,
  Users,
  Package,
  ClipboardList,
  Receipt,
} from "lucide-react";

export const EXPENSE_CATEGORIES = [
  { id: "fuel", label: "Fuel", icon: Fuel },
  { id: "transport", label: "Transport", icon: Car },
  { id: "rent", label: "Rent", icon: Home },
  { id: "utilities", label: "Utilities", icon: Zap },
  { id: "supplies", label: "Supplies", icon: ShoppingCart },
  { id: "salary", label: "Salary", icon: Users },
  { id: "inventory_restock", label: "Stock purchase", icon: Package },
  { id: "misc", label: "Other", icon: ClipboardList },
];

export function getExpenseCategoryIcon(categoryId) {
  return EXPENSE_CATEGORIES.find((c) => c.id === categoryId)?.icon || Receipt;
}
